'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactKonva = require('react-konva');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScaledRect = function ScaledRect(_ref) {
    var x = _ref.x,
        y = _ref.y,
        height = _ref.height,
        width = _ref.width,
        fill = _ref.fill,
        _ref$scalingFactor = _ref.scalingFactor,
        scalingFactor = _ref$scalingFactor === undefined ? 5 : _ref$scalingFactor;
    return _react2.default.createElement(_reactKonva.Rect, {
        x: x * scalingFactor,
        y: y * scalingFactor,
        height: height * scalingFactor,
        width: width * scalingFactor,
        fill: fill
    });
};

exports.default = ScaledRect;


//////////////////
// WEBPACK FOOTER
// ./node_modules/hash-heroes/lib/ScaledRect.js
// module id = 189
// module chunks = 0